// Arquivo gerado automaticamente por scripts/generate-image-data.mjs
// Não edite manualmente. Rode `npm run generate:image-data` após adicionar/remover imagens em public/images.

export const imageCollections = {
  "cardapio-de-pascoa": [
    {
      "id": "cardapio-de-pascoa-brigadeiro",
      "slug": "brigadeiro",
      "fileName": "brigadeiro.jpeg",
      "label": "Brigadeiro",
      "imageUrl": "/images/cardapio-de-pascoa/brigadeiro.jpeg",
      "alt": "Brigadeiro"
    },
    {
      "id": "cardapio-de-pascoa-ferreiro-rocher",
      "slug": "ferreiro-rocher",
      "fileName": "ferreiro-rocher.jpeg",
      "label": "Ferreiro Rocher",
      "imageUrl": "/images/cardapio-de-pascoa/ferreiro-rocher.jpeg",
      "alt": "Ferreiro Rocher"
    },
    {
      "id": "cardapio-de-pascoa-guloseimas",
      "slug": "guloseimas",
      "fileName": "guloseimas.jpeg",
      "label": "Guloseimas",
      "imageUrl": "/images/cardapio-de-pascoa/guloseimas.jpeg",
      "alt": "Guloseimas"
    },
    {
      "id": "cardapio-de-pascoa-m-m",
      "slug": "m-m",
      "fileName": "m&m.jpeg",
      "label": "M&M",
      "imageUrl": "/images/cardapio-de-pascoa/m&m.jpeg",
      "alt": "M&M"
    },
    {
      "id": "cardapio-de-pascoa-matilda",
      "slug": "matilda",
      "fileName": "matilda.jpeg",
      "label": "Matilda",
      "imageUrl": "/images/cardapio-de-pascoa/matilda.jpeg",
      "alt": "Matilda"
    },
    {
      "id": "cardapio-de-pascoa-ninho-com-nutela",
      "slug": "ninho-com-nutela",
      "fileName": "ninho-com-nutela.jpeg",
      "label": "Ninho Com Nutela",
      "imageUrl": "/images/cardapio-de-pascoa/ninho-com-nutela.jpeg",
      "alt": "Ninho Com Nutela"
    },
    {
      "id": "cardapio-de-pascoa-ninho-com-uva",
      "slug": "ninho-com-uva",
      "fileName": "ninho-com-uva.jpeg",
      "label": "Ninho Com Uva",
      "imageUrl": "/images/cardapio-de-pascoa/ninho-com-uva.jpeg",
      "alt": "Ninho Com Uva"
    },
    {
      "id": "cardapio-de-pascoa-ninho",
      "slug": "ninho",
      "fileName": "ninho.jpeg",
      "label": "Ninho",
      "imageUrl": "/images/cardapio-de-pascoa/ninho.jpeg",
      "alt": "Ninho"
    },
    {
      "id": "cardapio-de-pascoa-petisqueira",
      "slug": "petisqueira",
      "fileName": "petisqueira.jpeg",
      "label": "Petisqueira",
      "imageUrl": "/images/cardapio-de-pascoa/petisqueira.jpeg",
      "alt": "Petisqueira"
    },
    {
      "id": "cardapio-de-pascoa-prestigio",
      "slug": "prestigio",
      "fileName": "prestigio.jpeg",
      "label": "Prestigio",
      "imageUrl": "/images/cardapio-de-pascoa/prestigio.jpeg",
      "alt": "Prestigio"
    },
    {
      "id": "cardapio-de-pascoa-trufado-ninho-com-nutela-mouse-maracuja-brigadeiro",
      "slug": "trufado-ninho-com-nutela-mouse-maracuja-brigadeiro",
      "fileName": "trufado-ninho-com-nutela-mouse-maracuja-brigadeiro.jpeg",
      "label": "Trufado Ninho Com Nutela Mouse Maracuja Brigadeiro",
      "imageUrl": "/images/cardapio-de-pascoa/trufado-ninho-com-nutela-mouse-maracuja-brigadeiro.jpeg",
      "alt": "Trufado Ninho Com Nutela Mouse Maracuja Brigadeiro"
    }
  ],
  "carousel": [
    {
      "id": "carousel-brigadeiros-finos",
      "slug": "brigadeiros-finos",
      "fileName": "brigadeiros-finos.jpeg",
      "label": "Brigadeiros Finos",
      "imageUrl": "/images/carousel/brigadeiros-finos.jpeg",
      "alt": "Brigadeiros Finos"
    },
    {
      "id": "carousel-brigadeiros-tradicionais",
      "slug": "brigadeiros-tradicionais",
      "fileName": "brigadeiros-tradicionais.jpeg",
      "label": "Brigadeiros Tradicionais",
      "imageUrl": "/images/carousel/brigadeiros-tradicionais.jpeg",
      "alt": "Brigadeiros Tradicionais"
    },
    {
      "id": "carousel-coracao-de-brilho",
      "slug": "coracao-de-brilho",
      "fileName": "coracao-de-brilho.jpeg",
      "label": "Coracao De Brilho",
      "imageUrl": "/images/carousel/coracao-de-brilho.jpeg",
      "alt": "Coracao De Brilho"
    }
  ],
  "flags": [
    {
      "id": "flags-br",
      "slug": "br",
      "fileName": "br.svg",
      "label": "Br",
      "imageUrl": "/images/flags/br.svg",
      "alt": "Br"
    },
    {
      "id": "flags-es",
      "slug": "es",
      "fileName": "es.svg",
      "label": "Es",
      "imageUrl": "/images/flags/es.svg",
      "alt": "Es"
    },
    {
      "id": "flags-fr",
      "slug": "fr",
      "fileName": "fr.svg",
      "label": "Fr",
      "imageUrl": "/images/flags/fr.svg",
      "alt": "Fr"
    },
    {
      "id": "flags-jp",
      "slug": "jp",
      "fileName": "jp.svg",
      "label": "Jp",
      "imageUrl": "/images/flags/jp.svg",
      "alt": "Jp"
    },
    {
      "id": "flags-us",
      "slug": "us",
      "fileName": "us.svg",
      "label": "Us",
      "imageUrl": "/images/flags/us.svg",
      "alt": "Us"
    }
  ],
  "instagram": [
    {
      "id": "instagram-brigadeiro",
      "slug": "brigadeiro",
      "fileName": "brigadeiro.png",
      "label": "Brigadeiro",
      "imageUrl": "/images/instagram/brigadeiro.png",
      "alt": "Brigadeiro"
    },
    {
      "id": "instagram-encomende-ovo-pascoa",
      "slug": "encomende-ovo-pascoa",
      "fileName": "encomende-ovo-pascoa.jpeg",
      "label": "Encomende Ovo Pascoa",
      "imageUrl": "/images/instagram/encomende-ovo-pascoa.jpeg",
      "alt": "Encomende Ovo Pascoa"
    },
    {
      "id": "instagram-ovos-de-pascoa-trufados",
      "slug": "ovos-de-pascoa-trufados",
      "fileName": "ovos-de-pascoa-trufados.png",
      "label": "Ovos De Pascoa Trufados",
      "imageUrl": "/images/instagram/ovos-de-pascoa-trufados.png",
      "alt": "Ovos De Pascoa Trufados"
    }
  ],
  "logo": [
    {
      "id": "logo-logo-carlizdoces",
      "slug": "logo-carlizdoces",
      "fileName": "logo-carlizdoces.png",
      "label": "Logo Carlizdoces",
      "imageUrl": "/images/logo/logo-carlizdoces.png",
      "alt": "Logo Carlizdoces"
    }
  ],
  "novidades": [
    {
      "id": "novidades-bar-de-brigadeiro",
      "slug": "bar-de-brigadeiro",
      "fileName": "bar-de-brigadeiro.jpeg",
      "label": "Bar De Brigadeiro",
      "imageUrl": "/images/novidades/bar-de-brigadeiro.jpeg",
      "alt": "Bar De Brigadeiro"
    },
    {
      "id": "novidades-brigadeiros",
      "slug": "brigadeiros",
      "fileName": "brigadeiros.jpeg",
      "label": "Brigadeiros",
      "imageUrl": "/images/novidades/brigadeiros.jpeg",
      "alt": "Brigadeiros"
    },
    {
      "id": "novidades-sorteio-ovo-pascoa",
      "slug": "sorteio-ovo-pascoa",
      "fileName": "sorteio-ovo-pascoa.jpeg",
      "label": "Sorteio Ovo Pascoa",
      "imageUrl": "/images/novidades/sorteio-ovo-pascoa.jpeg",
      "alt": "Sorteio Ovo Pascoa"
    }
  ],
  "pedidos-de-doces": [],
  "tela-apresentacao": [
    {
      "id": "tela-apresentacao-palhaco",
      "slug": "palhaco",
      "fileName": "palhaco.png",
      "label": "Palhaco",
      "imageUrl": "/images/tela-apresentacao/palhaco.png",
      "alt": "Palhaco"
    }
  ]
}

